document.addEventListener('DOMContentLoaded', function() {
    const swiper = new Swiper('.featuredproducts_slider', {
        loop: true,
        centeredSlides: true, // Center the active slide
        slidesPerView: 3.2,  // Show 3 full slides + partial slides on both sides
        spaceBetween: 0, 
				on: {
					slideChange: function () {
						var activeSlide = this.slides[this.activeIndex];
						var box = activeSlide.querySelector('.z_slideBox');
						if (box) {
							var title = box.getAttribute('data-title');
							jQuery(".z-bestSellingBox .content h4").text(title);
							
						}
					}
				},
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 1.2,
                spaceBetween: 0,
            },
            768: {
                slidesPerView: 2.2, 
                spaceBetween: 0,
            },
            1024: {
                slidesPerView: 3.2, 
                spaceBetween: 0,
            },
        },
    });
});


$(".z-bestSellingBox .z-arrow.z-arrowLeft").click(function(){
    $(".featuredproducts_slider .swiper-button-prev").click();
});
jQuery(".z-bestSellingBox .z-arrow.z-arrowRight").click(function(){
    $(".featuredproducts_slider .swiper-button-next").click();
});




jQuery(document).ready(function($) {

    // ============================================
    // 1. TABS LOGIC
    // ============================================
    
    // Initialize: Hide all tab content except the one marked active
    $('.e-n-tabs').each(function() {
        var $activeTitle = $(this).find('.e-n-tab-title[aria-selected="true"]');
        
        // Hide all panels initially
        $(this).find('.e-n-tabs-content > [role="tabpanel"]').hide().removeClass('e-active');
        
        // Show the active one
        if ($activeTitle.length) {
            var targetId = $activeTitle.attr('aria-controls');
            $('#' + targetId).show().addClass('e-active');
        } else {
            // Fallback: click the first tab if none are active
            $(this).find('.e-n-tab-title').first().trigger('click');
        }
    });

    // Handle Click on Tab Titles
    $('.e-n-tab-title').on('click keydown', function(e) {
        // Support Enter/Space for accessibility
        if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();

        var $this = $(this);
        var targetControl = $this.attr('aria-controls');
        var $mainContainer = $this.closest('.e-n-tabs');

        // A. Toggle Buttons
        // Deactivate siblings
        $this.siblings().attr('aria-selected', 'false').attr('tabindex', '-1');
        // Activate clicked
        $this.attr('aria-selected', 'true').attr('tabindex', '0');

        // B. Toggle Content
        var $contentContainer = $mainContainer.find('.e-n-tabs-content');
        
        // Hide all direct children panels
        $contentContainer.children('[role="tabpanel"]').hide().removeClass('e-active');
        
        // Show the specific target panel
        $contentContainer.find('#' + targetControl).fadeIn(300).addClass('e-active');
    });

    // ============================================
    // 2. ACCORDION LOGIC (Inside the tabs)
    // ============================================
    
    // The HTML uses <details> and <summary>. 
    // This script enforces "Accordion" behavior (only one open at a time).
    
    $('.e-n-accordion-item-title').on('click', function(e) {
        e.preventDefault(); // Stop default HTML5 details behavior to handle it manually

        var $summary = $(this);
        var $clickedDetail = $summary.closest('details');
        var $accordionContainer = $clickedDetail.closest('.e-n-accordion');

        // Check if it is currently open
        var isOpen = $clickedDetail.attr('open');

        // Close ALL items in this specific accordion container
        $accordionContainer.find('details').removeAttr('open');
        $accordionContainer.find('.e-n-accordion-item-title').attr('aria-expanded', 'false');

        // If it was closed, open it now. (If it was open, we leave it closed -> toggle effect)
        if (typeof isOpen === 'undefined' || isOpen === false) {
            $clickedDetail.attr('open', '');
            $summary.attr('aria-expanded', 'true');
        }
    });
});



$(document).ready(function() {
    
    // Function to check if we are in mobile view
    function isMobileView() {
      // Use the same breakpoint as your CSS media query
      return window.matchMedia("(max-width: 768px)").matches;
    }

    // Initialize state on load
    if (isMobileView()) {
      // Ensure all content is hidden initially on mobile
      $('.footer-accordion-content').hide();
      $('.accordion-trigger').removeClass('active');
    }
    
    // Accordion click handler
    $('.accordion-trigger').on('click', function() {
      // Only run the accordion logic on mobile
      if (!isMobileView()) {
        return;
      }
      
      const $this = $(this);
      const $content = $this.next('.footer-accordion-content');
      
      if ($this.hasClass('active')) {
        // If already active, close it
        $content.slideUp(300);
        $this.removeClass('active');
      } else {
        // Close all other open accordions
        $('.accordion-trigger').removeClass('active');
        $('.footer-accordion-content').slideUp(300);
        
        // Open the current one
        $content.slideDown(300);
        $this.addClass('active');
      }
    });

    // Optional: Re-initialize on window resize (e.g., if user rotates tablet)
    $(window).resize(function() {
      if (!isMobileView()) {
        // If view is desktop, ensure all menus are visible and remove active class
        $('.footer-accordion-content').show();
        $('.accordion-trigger').removeClass('active');
      } else {
        // If view is mobile, hide non-active menus
        $('.footer-accordion-content').hide();
      }
    });

  });



jQuery(document).on("click", "main#MainContent product-info>.page-width>.product .product__info-wrapper.grid__item section.product__info-container product-form.product-form .product-form__buttons .z_productCustomButton button#z_addToCart", function(){
    if(jQuery("main#MainContent product-info>.page-width>.product .product__info-wrapper.grid__item").hasClass("ring-size-true")){
        var ringsize = jQuery("select#selectRingSize").val();
        if(ringsize == ""){
            jQuery("main#MainContent product-info>.page-width>.product .product__info-wrapper.grid__item section.product__info-container .product-form__input.product-form__input--dropdown.z-ringSizeBox").addClass("error");
        }else{
            jQuery("main#MainContent product-info>.page-width>.product .product__info-wrapper.grid__item section.product__info-container product-form.product-form .product-form__buttons button.product-form__submit").click();
        }
    }else{
        jQuery("main#MainContent product-info>.page-width>.product .product__info-wrapper.grid__item section.product__info-container product-form.product-form .product-form__buttons button.product-form__submit").click();
    }
});


jQuery(document).on("click", "main#MainContent product-info>.page-width>.product .product__info-wrapper.grid__item section.product__info-container product-form.product-form .product-form__buttons .z_productCustomButton button#z_butItNow", function(){
    if(jQuery("main#MainContent product-info>.page-width>.product .product__info-wrapper.grid__item").hasClass("ring-size-true")){
        var ringsize = jQuery("select#selectRingSize").val();
        if(ringsize == ""){
            jQuery("main#MainContent product-info>.page-width>.product .product__info-wrapper.grid__item section.product__info-container .product-form__input.product-form__input--dropdown.z-ringSizeBox").addClass("error");
        }else{
            jQuery("main#MainContent product-info>.page-width>.product .product__info-wrapper.grid__item section.product__info-container product-form.product-form .product-form__buttons button.shopify-payment-button__button").click();
        }
    }else{
        jQuery("main#MainContent product-info>.page-width>.product .product__info-wrapper.grid__item section.product__info-container product-form.product-form .product-form__buttons button.shopify-payment-button__button").click();
    }
});

jQuery(document).on("change", "main#MainContent product-info>.page-width>.product .product__info-wrapper.grid__item section.product__info-container .product-form__input.product-form__input--dropdown.z-ringSizeBox.error select#selectRingSize", function(){
   jQuery("main#MainContent product-info>.page-width>.product .product__info-wrapper.grid__item section.product__info-container .product-form__input.product-form__input--dropdown.z-ringSizeBox").removeClass("error"); 
});